<div class="gallery-top swiper-container my-5" [swiper]="swiperAutoplayConfig">

  <div class="swiper-wrapper">

    <div *ngFor="let item of list" class="card swiper-slide mx-2 d-flex flex-column">
      <img [src]="item.image" class="card-img-top" alt="..." style="width: 100% !important; height: 200px;">
      <div class="card-body">
        <h5 class="card-title">{{item.name}}</h5>
      </div>
    </div>

  </div>
  <!-- Add Pagination -->
  <div class="swiper-pagination"></div>
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
</div>
